import React from "react";
import "./bodyCardEventSlider.sass";

export default function TeamSlider({ imgTeam, altTeam, nameTeam, pointsTeam, isMiddle, urlEvento, classTeam, classGame, isLeft }) {

    let classNextGame = "clarosports-next-game";
    let classErrorGame = "clarosports-error-game";

    return (
        <a className="container-team-slider" href={urlEvento} target="_top">

            <div className="team-slider-top">
                {!isLeft &&
                    <>
                        {(String(classGame).toLowerCase() !== classNextGame && String(classGame).toLowerCase() !== classErrorGame)
                            ? String(urlEvento).length > 0
                                ? <a className={"team-score"} href={urlEvento} target="_top">
                                    {!isMiddle &&
                                        <span className={classTeam}>{pointsTeam}</span>
                                    }
                                </a>
                                : <p className={"team-score"}>
                                    {!isMiddle &&
                                        <span className={classTeam}>{pointsTeam}</span>
                                    }
                                </p>
                            : null
                        }
                    </>
                }

                {String(urlEvento).length > 0
                    ?
                    <a className={isLeft ? "team-img-name team-left" : "team-img-name team-right"} href={urlEvento} target="_top">
                        {!isMiddle &&
                            <img className="team-img" alt={altTeam} src={imgTeam} loading="lazy"></img>
                        }
                    </a>
                    : <p className={isLeft ? "team-img-name team-left" : "team-img-name team-right"}>
                        {!isMiddle &&
                            <img className="team-img" alt={altTeam} src={imgTeam} loading="lazy"></img>
                        }
                    </p>
                }

                {isLeft &&
                    <>
                        {(String(classGame).toLowerCase() !== classNextGame && String(classGame).toLowerCase() !== classErrorGame)
                            ? String(urlEvento).length > 0
                                ? <a className={"team-score"} href={urlEvento} target="_top">
                                    {!isMiddle &&
                                        <p className={classTeam}>{pointsTeam}</p>
                                    }
                                </a>
                                : <p className={"team-score"}>
                                    {!isMiddle &&
                                        <span className={classTeam}>{pointsTeam}</span>
                                    }
                                </p>
                            : null
                        }
                    </>
                }
            </div>

            <div className="team-slider-bottom">
                <p className="team-name"> {nameTeam} </p>
            </div>
        </a>
    );
}